import { render } from "./Menu.vue?vue&type=template&id=7851288b&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./style.css?vue&type=style&index=0&id=7851288b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7851288b"

export default script